import "url-polyfill";
import "/polyfills/closest";
import "/modules/modals";
import events from "/events";
import cookie from "/utils/cookie";

const init = config => {

  if (!config.guest) {
    return;
  }

  if (cookie("modal-leaving-popup")) {
    return;
  }

  if (!document.querySelector(".leaving-popup-container")){
    return;
  }

  const pageExceptionClasses = [
    "body.users.login__login",
    "body.users.login__signup",
    "body.pages__jobs",
    "body.pages__disclaimer",
    "body.pages__press",
    "body.pages__privacy",
    "body.pages__candidate_privacy",
    "body.pages__tos",
    "body.pages__cookie_consent",
    "body.pages__sitemap",
    "body.purchase",
    ".normal-main-banner__body--coupon",
    ".normal-main-banner__body--voucher",
    ".reset-password",
    ".email-thank-you-body",
    ".email-unsubscribe-sad",
    ".landing_pages__show"
  ];

  if (document.querySelector(pageExceptionClasses.join(","))) {
    return;
  }

  // Query params based skip
  var urlParams = new URL(window.location.href).searchParams;

  if (urlParams.get("utm_source") === "quora" && urlParams.get("utm_medium") === "paid") {
    return;
  }

  let disabled = false;

  const open = () => {
    events.emit("modal:leaving-popup:open");
    events.track("Conversion", "LeavingPopup", "Show");
  };

  const outCallback = e => {
    if (disabled) {
      return;
    }
    const from = e.relatedTarget;
    if (!from || from.nodeName === "HTML") {
      open();
    }
  };

  document.addEventListener("mouseout", outCallback);

  document.addEventListener("focus", e => {
    // FF trigger an error when calling closest on document
    if (e.target.closest) {
      const target = e.target.closest("input");
      if (!target) {
        return;
      }
      disabled = true;
    }
  });

  document.addEventListener("blur", e => {
    // FF trigger an error when calling closest on document
    if (e.target.closest) {
      const target = e.target.closest("input");
      if (!target) {
        return;
      }
      disabled = false;
    }
  });

  events.on("modal:leaving-popup:opened", modal => {
    const input = modal.querySelector("input[type='email']");
    if (input) {
      input.focus();
    }
    document.removeEventListener("mouseout", outCallback);
  });

  // Trigger popup from specs
  window.triggerLeavingPopup = () => {
    open();
  };
};

events.on("setup:ready", init);
